export default __webpack_public_path__ + "static/media/3885.208a6b19.png";